import type { FreelancerInsuranceInformationPageLocales } from '../types';

const freelancerInsuranceInformationPageLocales: FreelancerInsuranceInformationPageLocales =
  {
    confirmDeleteMessage:
      'Weet je zeker dat je {{docName}} wilt verwijderen? Mocht je een vergissing maken, dan kan je het diploma handmatig weer toevoegen.',
    documentAdded: 'Document succesvol opgeslagen.',
    documentDeleted: 'Document verwijderd!',
    fileRequired: 'U moet een bestand selecteren.',
    helperMessage:
      'Upload hieronder het bewijs van de aansprakelijkheidsverzekering van je bedrijf.',
    removeDocument: 'Document verwijderen',
    saveDocument: 'Document opslaan',
    title: 'Verzekeringen',
    uploadErrorMessage: 'Kan bestand niet uploaden, probeer later opnieuw.',
    uploadProof: 'Upload bewijs',
    wantToContinue: 'Weet je zeker dat je door wilt gaan?',
    wrongFileExtension:
      'Document heeft niet de juiste extensie. Upload een PDF-, JPG- of PNG bestand.',
    yesRemoveDocument: 'Ja, document verwijderen',
  };

export default freelancerInsuranceInformationPageLocales;
